import React, { useState, useEffect, useCallback } from "react";
import HomeSettingView from "./home.view";
import { useSelector } from "react-redux";
import * as SettingService from "../../../services/SettingService";
import * as VisualMainQueueService from "../../../services/VisualMainQueueService";

import {
  getAuthUserSelector,
  getRoleSelector,
} from "../../../store/selectors/authSelector";

const HomeSettingContainer = () => {
  const userInfo = useSelector(getAuthUserSelector);
  const role = useSelector(getRoleSelector);
  const [canSyncroData, setCanSyncroData] = useState(false);
  const [queueData, setQueueData] = useState(null);

  const loadData = useCallback(async () => {
    const result = await SettingService.listAllSettings();
    const visualMainQueue = await VisualMainQueueService.listVisualMainQueue(
      {},
    );

    if (result) {
      setCanSyncroData(result || false);
      setQueueData(visualMainQueue);
    }
  }, []);

  const refresh = useCallback(() => {
    loadData();
  }, [loadData]);

  useEffect(() => {
    loadData();
  }, [loadData]);
  return (
    <>
      <HomeSettingView
        userInfo={userInfo}
        role={role}
        canSyncroData={canSyncroData}
        queueData={queueData}
        refresh={refresh}
      />
    </>
  );
};

HomeSettingContainer.propTypes = {};

export default HomeSettingContainer;
